import Block2Image from './post-listing-block-2-image.jpg';
import Block2ImageWebp from './post-listing-block-2-image.webp';
import Block2Image2x from './post-listing-block-2-image@2x.jpg';
import Block2Image2xWebp from './post-listing-block-2-image@2x.webp';
import Block2Overlay from './post-listing-block-2-overlay.png';
import Block2OverlayWebp from './post-listing-block-2-overlay.webp';
import Block2Overlay2x from './post-listing-block-2-overlay@2x.png';
import Block2Overlay2xWebp from './post-listing-block-2-overlay@2x.webp';
import Block2OverlayWide from './post-listing-block-2-overlay-wide.png';
import Block2OverlayWideWebp from './post-listing-block-2-overlay-wide.webp';
import Block2OverlayWide2x from './post-listing-block-2-overlay-wide@2x.png';
import Block2OverlayWide2xWebp from './post-listing-block-2-overlay-wide@2x.webp';
import Block3Image from './post-listing-block-3-image.jpg';
import Block3ImageWebp from './post-listing-block-3-image.webp';
import Block3Image2x from './post-listing-block-3-image@2x.jpg';
import Block3Image2xWebp from './post-listing-block-3-image@2x.webp';
import Block3Overlay from './post-listing-block-3-overlay.png';
import Block3OverlayWebp from './post-listing-block-3-overlay.webp';
import Block3Overlay2x from './post-listing-block-3-overlay@2x.png';
import Block3Overlay2xWebp from './post-listing-block-3-overlay@2x.webp';
import Block3OverlayWide from './post-listing-block-3-overlay-wide.png';
import Block3OverlayWideWebp from './post-listing-block-3-overlay-wide.webp';
import Block3OverlayWide2x from './post-listing-block-3-overlay-wide@2x.png';
import Block3OverlayWide2xWebp from './post-listing-block-3-overlay-wide@2x.webp';
import Block4Image from './post-listing-block-4-image.jpg';
import Block4ImageWebp from './post-listing-block-4-image.webp';
import Block4Image2x from './post-listing-block-4-image@2x.jpg';
import Block4Image2xWebp from './post-listing-block-4-image@2x.webp';
import Block4Overlay from './post-listing-block-4-overlay.png';
import Block4OverlayWebp from './post-listing-block-4-overlay.webp';
import Block4Overlay2x from './post-listing-block-4-overlay@2x.png';
import Block4Overlay2xWebp from './post-listing-block-4-overlay@2x.webp';
import Block4OverlayWide from './post-listing-block-4-overlay-wide.png';
import Block4OverlayWideWebp from './post-listing-block-4-overlay-wide.webp';
import Block4OverlayWide2x from './post-listing-block-4-overlay-wide@2x.png';
import Block4OverlayWide2xWebp from './post-listing-block-4-overlay-wide@2x.webp';
import Block5Image from './post-listing-block-5-image.jpg';
import Block5ImageWebp from './post-listing-block-5-image.webp';
import Block5Image2x from './post-listing-block-5-image@2x.jpg';
import Block5Image2xWebp from './post-listing-block-5-image@2x.webp';
import Block5Overlay from './post-listing-block-5-overlay.png';
import Block5OverlayWebp from './post-listing-block-5-overlay.webp';
import Block5Overlay2x from './post-listing-block-5-overlay@2x.png';
import Block5Overlay2xWebp from './post-listing-block-5-overlay@2x.webp';
import Block5OverlayWide from './post-listing-block-5-overlay-wide.png';
import Block5OverlayWideWebp from './post-listing-block-5-overlay-wide.webp';
import Block5OverlayWide2x from './post-listing-block-5-overlay-wide@2x.png';
import Block5OverlayWide2xWebp from './post-listing-block-5-overlay-wide@2x.webp';
import Block6StepOne from './post-listing-block-6-image-step1.png';
import Block6StepOneWebp from './post-listing-block-6-image-step1.webp';
import Block6StepOne2x from './post-listing-block-6-image-step1@2x.png';
import Block6StepOne2xWebp from './post-listing-block-6-image-step1@2x.webp';
import Block6StepTwo from './post-listing-block-6-image-step2.png';
import Block6StepTwoWebp from './post-listing-block-6-image-step2.webp';
import Block6StepTwo2x from './post-listing-block-6-image-step2@2x.png';
import Block6StepTwo2xWebp from './post-listing-block-6-image-step2@2x.webp';
import Block6StepThree from './post-listing-block-6-image-step3.png';
import Block6StepThreeWebp from './post-listing-block-6-image-step3.webp';
import Block6StepThree2x from './post-listing-block-6-image-step3@2x.png';
import Block6StepThree2xWebp from './post-listing-block-6-image-step3@2x.webp';

import Block7Image from './post-listing-block-7-image.jpg';
import Block7ImageWebp from './post-listing-block-7-image.webp';
import Block7Image2x from './post-listing-block-7-image@2x.jpg';
import Block7Image2xWebp from './post-listing-block-7-image@2x.webp';

import CrossPromoteOne from './post-listing-cross-promotoe-ico-1.png';
import CrossPromoteOneWebp from './post-listing-cross-promotoe-ico-1.webp';
import CrossPromoteOne2x from './post-listing-cross-promotoe-ico-1@2x.png';
import CrossPromoteOne2xWebp from './post-listing-cross-promotoe-ico-1@2x.webp';
import CrossPromoteTwo from './post-listing-cross-promotoe-ico-2.png';
import CrossPromoteTwoWebp from './post-listing-cross-promotoe-ico-2.webp';
import CrossPromoteTwo2x from './post-listing-cross-promotoe-ico-2@2x.png';
import CrossPromoteTwo2xWebp from './post-listing-cross-promotoe-ico-2@2x.webp';
import CrossPromoteThree from './post-listing-cross-promotoe-ico-3.png';
import CrossPromoteThreeWebp from './post-listing-cross-promotoe-ico-3.webp';
import CrossPromoteThree2x from './post-listing-cross-promotoe-ico-3@2x.png';
import CrossPromoteThree2xWebp from './post-listing-cross-promotoe-ico-3@2x.webp';
import CtaBackground from './post-listing-cta-background.jpg';
import CtaBackgroundWebp from './post-listing-cta-background.webp';
import CtaBackground2x from './post-listing-cta-background@2x.jpg';
import CtaBackground2xWebp from './post-listing-cta-background@2x.webp';

import HeroImage from './post-listing-hero.jpg';
import HeroImageWebp from './post-listing-hero.webp';
import HeroImage2x from './post-listing-hero@2x.jpg';
import HeroImage2xWebp from './post-listing-hero@2x.webp';

import ZillowLogo from './post-listing-block-2-zillow.png';
import ZillowLogoWebp from './post-listing-block-2-zillow.webp';
import ZillowLogo2x from './post-listing-block-2-zillow@2x.png';
import ZillowLogo2xWebp from './post-listing-block-2-zillow@2x.webp';
import TruliaLogo from './post-listing-block-2-trulia.png';
import TruliaLogoWebp from './post-listing-block-2-trulia.webp';
import TruliaLogo2x from './post-listing-block-2-trulia@2x.png';
import TruliaLogo2xWebp from './post-listing-block-2-trulia@2x.webp';
import HotPadsLogo from './post-listing-block-2-hotpads.png';
import HotPadsLogoWebp from './post-listing-block-2-hotpads.webp';
import HotPadsLogo2x from './post-listing-block-2-hotpads@2x.png';
import HotPadsLogo2xWebp from './post-listing-block-2-hotpads@2x.webp';

export const cta1ListingLandingPageBackgroundImages = {
  webp: {
    extraSmall: Block2OverlayWebp,
    extraSmall2x: Block2Overlay2xWebp,
    small: Block2OverlayWideWebp,
    small2x: Block2OverlayWide2xWebp,
    medium: Block2OverlayWideWebp,
    medium2x: Block2OverlayWide2xWebp,
    extraLarge: Block2ImageWebp,
    extraLarge2x: Block2Image2xWebp,
  },
  default: {
    extraSmall: Block2Overlay,
    extraSmall2x: Block2Overlay2x,
    small: Block2OverlayWide,
    small2x: Block2OverlayWide2x,
    medium: Block2OverlayWide,
    medium2x: Block2OverlayWide2x,
    extraLarge: Block2Image,
    extraLarge2x: Block2Image2x,
  },
};

export const cta2ListingLandingPageBackgroundImages = {
  webp: {
    extraSmall: Block3OverlayWebp,
    extraSmall2x: Block3Overlay2xWebp,
    small: Block3OverlayWideWebp,
    small2x: Block3OverlayWide2xWebp,
    medium: Block3OverlayWideWebp,
    medium2x: Block3OverlayWide2xWebp,
    extraLarge: Block3ImageWebp,
    extraLarge2x: Block3Image2xWebp,
  },
  default: {
    extraSmall: Block3Overlay,
    extraSmall2x: Block3Overlay2x,
    small: Block3OverlayWide,
    small2x: Block3OverlayWide2x,
    medium: Block3OverlayWide,
    medium2x: Block3OverlayWide2x,
    extraLarge: Block3Image,
    extraLarge2x: Block3Image2x,
  },
};

export const cta3ListingLandingPageBackgroundImages = {
  webp: {
    extraSmall: Block4OverlayWebp,
    extraSmall2x: Block4Overlay2xWebp,
    small: Block4OverlayWideWebp,
    small2x: Block4OverlayWide2xWebp,
    medium: Block4OverlayWideWebp,
    medium2x: Block4OverlayWide2xWebp,
    extraLarge: Block4ImageWebp,
    extraLarge2x: Block4Image2xWebp,
  },
  default: {
    extraSmall: Block4Overlay,
    extraSmall2x: Block4Overlay2x,
    small: Block4OverlayWide,
    small2x: Block4OverlayWide2x,
    medium: Block4OverlayWide,
    medium2x: Block4OverlayWide2x,
    extraLarge: Block4Image,
    extraLarge2x: Block4Image2x,
  },
};

export const cta4ListingLandingPageBackgroundImages = {
  webp: {
    extraSmall: Block5OverlayWebp,
    extraSmall2x: Block5Overlay2xWebp,
    small: Block5OverlayWideWebp,
    small2x: Block5OverlayWide2xWebp,
    medium: Block5OverlayWideWebp,
    medium2x: Block5OverlayWide2xWebp,
    extraLarge: Block5ImageWebp,
    extraLarge2x: Block5Image2xWebp,
  },
  default: {
    extraSmall: Block5Overlay,
    extraSmall2x: Block5Overlay2x,
    small: Block5OverlayWide,
    small2x: Block5OverlayWide2x,
    medium: Block5OverlayWide,
    medium2x: Block5OverlayWide2x,
    extraLarge: Block5Image,
    extraLarge2x: Block5Image2x,
  },
};

export default {
  HeroImage,
  HeroImageWebp,
  HeroImage2x,
  HeroImage2xWebp,

  ZillowLogo,
  ZillowLogoWebp,
  ZillowLogo2x,
  ZillowLogo2xWebp,
  TruliaLogo,
  TruliaLogoWebp,
  TruliaLogo2x,
  TruliaLogo2xWebp,
  HotPadsLogo,
  HotPadsLogoWebp,
  HotPadsLogo2x,
  HotPadsLogo2xWebp,

  Block2Overlay,
  Block2OverlayWebp,
  Block2Overlay2x,
  Block2Overlay2xWebp,

  Block3Overlay,
  Block3OverlayWebp,
  Block3Overlay2x,
  Block3Overlay2xWebp,

  Block4Overlay,
  Block4OverlayWebp,
  Block4Overlay2x,
  Block4Overlay2xWebp,

  Block5Overlay,
  Block5OverlayWebp,
  Block5Overlay2x,
  Block5Overlay2xWebp,

  Block6StepOne,
  Block6StepOneWebp,
  Block6StepOne2x,
  Block6StepOne2xWebp,
  Block6StepTwo,
  Block6StepTwoWebp,
  Block6StepTwo2x,
  Block6StepTwo2xWebp,
  Block6StepThree,
  Block6StepThreeWebp,
  Block6StepThree2x,
  Block6StepThree2xWebp,

  Block7Image,
  Block7ImageWebp,
  Block7Image2x,
  Block7Image2xWebp,

  CrossPromoteOne,
  CrossPromoteOneWebp,
  CrossPromoteOne2x,
  CrossPromoteOne2xWebp,
  CrossPromoteTwo,
  CrossPromoteTwoWebp,
  CrossPromoteTwo2x,
  CrossPromoteTwo2xWebp,
  CrossPromoteThree,
  CrossPromoteThreeWebp,
  CrossPromoteThree2x,
  CrossPromoteThree2xWebp,

  CtaBackground,
  CtaBackgroundWebp,
  CtaBackground2x,
  CtaBackground2xWebp,
};
